import { render, staticRenderFns } from "./WidgetModelsRepair.vue?vue&type=template&id=40888155"
import script from "./WidgetModelsRepair.vue?vue&type=script&lang=ts"
export * from "./WidgetModelsRepair.vue?vue&type=script&lang=ts"
import style0 from "./WidgetModelsRepair.vue?vue&type=style&index=0&id=40888155&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports